const MobileOnly = ({ className = "", children, ...rest }) => {
  return (
    <div className={`md:hidden ${className}`} {...rest}>
      {children}
    </div>
  )
}

export default MobileOnly
